import React, { useCallback, useMemo, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useCompanyStore, usePatientStore } from '../../stores';
import AnesthetistInsuranceCardForm from './AnesthetistInsuranceCardForm';
import { submitInsuranceCard } from '../../processes/anesthetist-questionary';
import { showErrorToast, showSuccessToast } from '@amigoapp/doca-react';

const AnesthetistInsuranceCardFormContainer = () => {
	const { companySettings: { settings } } = useCompanyStore();
	const { patient, setPatient } = usePatientStore();
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const currentInsuranceCard = useMemo(() => patient?.insurance_card_file ? [patient?.insurance_card_file] : [], [patient]);
	const fileInputRef = useRef(currentInsuranceCard);

	const mountInsuranceCardFormData = useCallback((file) => {
		if (!file) return null;

		const formData = new FormData();

		formData.append('file', file);

		return formData;
	}, []);

	const handleFileSelect = useCallback((files) => {
		if (files?.target?.value?.[0]) {
			fileInputRef.current = files.target.value[0];
		} else {
			fileInputRef.current = null;
		}
	}, []);

	const handleSkip = useCallback(() => {
		history.push('/anesthetist-signature');
	}, [history]);

	const handleContinue = useCallback(async () => {
		if (currentInsuranceCard === fileInputRef.current) {
			history.push('/anesthetist-signature');
			return;
		}

		setLoading(true);

		const { data, error } = await submitInsuranceCard(
			mountInsuranceCardFormData(fileInputRef.current)
		);

		if (error) {
			setLoading(false);
			showErrorToast('Erro ao enviar a carteirinha de convênio.');
		} else {
			showSuccessToast('Carteirinha de convênio enviada com sucesso.');

			setPatient({
				...patient,
				insurance_card_file: data
			});

			setLoading(false);

			history.push('/anesthetist-signature');
		}
	}, [history, mountInsuranceCardFormData, patient, setPatient, currentInsuranceCard, fileInputRef]);

	return (
		<AnesthetistInsuranceCardForm
			loading={loading}
			currentInsuranceCard={currentInsuranceCard}
			onFileSelect={handleFileSelect}
			variant={settings?.theme?.name}
			onContinue={handleContinue}
			handleSkip={handleSkip}
		/>
	);
};

export default AnesthetistInsuranceCardFormContainer;
